import styled from "@emotion/styled"
import { getMediaQueryMin, spacingFluidSm, spacingFluidXl } from "@porsche-design-system/components-react/emotion"

export const ContentWrapper = styled.div({
	boxSizing: "border-box",
	margin: "0 auto",
	maxWidth: "1920px",
	paddingLeft: spacingFluidSm,
	paddingRight: spacingFluidSm,

	[getMediaQueryMin("xl")]: {
		paddingLeft: spacingFluidXl,
		paddingRight: spacingFluidXl,
	},
})
